export class Pagination {
  Page: number;
  Pages: number;
  PerPage: number;
  Total: number;
}
